export default __webpack_public_path__ + "static/media/announcement_5.b339fd6f.png";